import AnimationClip from '../AnimationClip';
import { Tween, Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import OverlayComponent from '../../../Component/UI/Overlay';
import Interactable from '../../../Component/Interactable';

export class OverlayFadeIn extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const renderable: Renderable = gameObject.getComponent(Renderable);
        const overlay: OverlayComponent = gameObject.getComponent(
            OverlayComponent
        );

        if (overlay.preventInteraction) {
            gameObject.getComponent(Interactable).enabled =
                overlay.preventInteraction;
        }

        renderable.alpha = 0;
        renderable.visible = true;

        const fadeInTween: Tween = this.getTween(renderable);

        fadeInTween.to({ alpha: meta?.alpha || 0.9 }, 500).easing(Easing.Linear.None);

        yield* this.startTween(fadeInTween);
    }
}
